import React from 'react';
const comparisonRows = [{
  without: 'Dudás qué hacer',
  with: 'Actuás con claridad'
}, {
  without: 'Improvisás',
  with: 'Seguís un proceso'
}, {
  without: 'Tenés miedo a equivocarte',
  with: 'Ganás seguridad'
}, {
  without: 'Todo es confuso',
  with: 'Tenés control'
}];
export function ComparisonTableExtended() {
  return <section className="bg-brand-dark text-white py-5 px-5" data-id="element-76">
      <div className="max-w-xl mx-auto" data-id="element-77">
        <h3 className="text-base md:text-lg font-black text-white mb-4 flex items-center gap-2" data-id="element-78">
          🧠 TABLA COMPARATIVA
        </h3>

        {/* Column headers */}
        <div className="grid grid-cols-2 gap-3 mb-3" data-id="element-79">
          <div className="text-xs font-bold text-red-400 flex items-center gap-1" data-id="element-80">
            ❌ Sin sistema
          </div>
          <div className="text-xs font-bold text-green-400 flex items-center gap-1" data-id="element-81">
            ✅ Con sistema
          </div>
        </div>

        {/* Rows */}
        <div className="space-y-2" data-id="element-82">
          {comparisonRows.map((row, idx) => <div key={idx} className="grid grid-cols-2 gap-3 border-t border-gray-800/60 pt-3" data-id="element-83">
              <p className="text-xs text-gray-500 leading-relaxed" data-id="element-84">
                {row.without}
              </p>
              <p className="text-xs text-gray-300 leading-relaxed" data-id="element-85">
                {row.with}
              </p>
            </div>)}
        </div>
      </div>
    </section>;
}